import "./AppleCard.css";

function AppleCard() {
    return (
        <section className="apple-card cursorP">
            <div className="container-fluid">
                <div className="applecard-wrapper">
                    <div className="applecard-logo"></div>
                    <h3 className="name2 pb-1 d-md-none">
                        Save 5% on Apple products
                        <br />
                        with a new Apple Card
                        <br />
                        through December 25.
                    </h3>
                    <h6 className="d-md-none">
                        Only at Apple.
                        <br />
                        Exclusions and terms apply.<sup>1</sup>
                    </h6>
                    <h3 className="name2 pb-1 d-none d-md-block">
                        Save 5% on Apple products with a
                        <br />
                        new Apple Card through December 25.
                    </h3>
                    <h6 className="d-none d-md-block">
                        Only at Apple. Exclusions and terms apply.<sup>1</sup>
                    </h6>
                    <div className="links-blue">
                        <ul className="list-inline">
                            <li className="list-inline-item apply-now">
                                <a href="">Learn more</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="">Apply now</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AppleCard;
